import { useQuery } from '@tanstack/react-query';

import { ACCOUNT_QUERY_KEY } from '@hcs/http-clients';

import { AuthApi } from '../api';

export const useAccount = () => {
  return useQuery([ACCOUNT_QUERY_KEY], async () => {
    return await AuthApi.fetchAccount();
  });
};
